import { useState, useEffect } from 'react';
import {
  getPlace,
  getSearchPredictions,
  getDevelopments,
} from '../../../api/index';

const uuid = sessionStorage.getItem('uuid');

const useDevelopmentSearch = ({
  searchTerm,
  setSearchTerm,
  setSearchBoxVisiblity,
  setIsLocationSearch,
}) => {
  const [searchableDevelopments, setSearchableDevelopments] = useState({
    items: [],
  });
  const [value, setValue] = useState(searchTerm || '');
  const [complete, setComplete] = useState(false);
  const [developmentResults, setDevelopmentResults] = useState({});
  const [predictivePlaceResults, setPredictivePlaceResults] = useState({});
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [geoPosition, setCoords] = useState({
    latitude: '',
    longitude: '',
  });

  useEffect(() => {
    const fetchDevelopments = async () => {
      const result = await getDevelopments();
      setSearchableDevelopments(result.data);
    };

    fetchDevelopments();
  }, []);

  const searchLocation = async (locationValue) => {
    const result = await getSearchPredictions(locationValue, uuid);
    if (result) {
      setPredictivePlaceResults(result.data);
    }
  };

  const onPredictiveSearchChange = (e) => {
    setComplete(false);

    if (e.target.value.length < 1) {
      setSearchBoxVisiblity && setSearchBoxVisiblity(false);
    }

    if (e.target.value.length >= 5) {
      setSearchBoxVisiblity && setSearchBoxVisiblity(true);
      searchLocation(e.target.value);
    }

    setValue(e.target.value);

    const results = searchableDevelopments.filter((development) => {
      if (
        development.street
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        development.title
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        development.city.toLowerCase().includes(e.target.value.toLowerCase())
      ) {
        return development;
      }
    });

    setDevelopmentResults(results);
  };

  const setPlace = async (item) => {
    const searchBoxElement = document.querySelector('.search-box');

    const { place_id } = item;

    const result = await getPlace(place_id, uuid);

    if (result) {
      const coords = result.data.result.geometry;
      setSearchTerm && setSearchTerm(item.description);
      setComplete(true);
      setValue(item.description);
      setSearchBoxVisiblity && setSearchBoxVisiblity(false);
      setIsLocationSearch && setIsLocationSearch(true);
      setCoords({
        latitude: coords.location.lat,
        longitude: coords.location.lng,
      });

      // if on homepage searchbox..
      if (typeof searchBoxElement !== 'undefined' && searchBoxElement != null) {
        document.querySelector('.search-box').submit();
      }
    }
  };

  const onChangeLocation = ({ coords }) => {
    setComplete(true);
    setValue('Your Location');
    setSearchTerm && setSearchTerm('Your Location');
    setIsLocationSearch && setIsLocationSearch(true);
    setCoords({
      latitude: coords.latitude,
      longitude: coords.longitude,
    });

    setLoadingLocation(false);
    document.querySelector('.search-box').submit();
  };

  const onError = (error) => {
    // Removed below: for sake of UI.
    // alert('Your Web browser has blocked "Access to your Location" please change these settings to search by your location.')
    setLoadingLocation(false);
  };

  const onGetUsersLocation = () => {
    const geo = navigator.geolocation;
    const options = {
      enableHighAccuracy: true,
      maximumAge: 0,
    };
    if (geo) {
      setLoadingLocation(true);
      geo.getCurrentPosition(onChangeLocation, onError, options);
    } else {
      alert('not supported by your browser');
      setLoadingLocation(false);
    }
  };

  return {
    value,
    complete,
    developmentResults,
    predictivePlaceResults,
    loadingLocation,
    geoPosition,
    searchableDevelopments,
    onPredictiveSearchChange,
    onGetUsersLocation,
    setPlace,
  };
};

export default useDevelopmentSearch;
